/* SellEton "Ask SellEton" under the header search (2026-10-25, Dara: moving words + AI behind the search, products only, safe).
   Adds to the existing Empire live search; changes none of its files. Product words keep the normal search.
   A question shows one "Ask SellEton" row; pressing it (or Enter on a question) shows the answer under the box. */
(function () {
  var cfg = document.getElementById('se-search-ask');
  if (!cfg) return;
  try {
    if (/[?&]chat=preview\b/.test(location.search)) sessionStorage.setItem('se_chat_preview', '1');
    if (cfg.dataset.mode !== 'live' && sessionStorage.getItem('se_chat_preview') !== '1') return;
  } catch (e) { if (cfg.dataset.mode !== 'live') return; }

  var ENDPOINT = cfg.dataset.endpoint;
  var HINTS = ['What are you looking for?', 'A floor scale for pallets', 'An indicator that prints', 'Load cells for a 4x4 scale', 'Where is my order?', 'A washdown bench scale'];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SAFE = /^https:\/\/(selletonscales\.com|www\.selletonscales\.com|youtu\.be|www\.youtube\.com|tools\.usps\.com|www\.ups\.com|www\.fedex\.com|scaleregistry\.com)\//i;
  var opened = Date.now();

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isQuestion(q) {
    q = q.trim();
    if (q.length < 6) return false;
    return /\?$/.test(q) || /^(how|which|what|where|can|do|does|is|are|why|when|should|need|my order|track)\b/i.test(q) || q.split(/\s+/).length >= 5;
  }
  function label(u, titles) {
    if (titles && titles[u]) return titles[u].length > 70 ? titles[u].slice(0, 67) + '...' : titles[u];
    var m = u.match(/\/products\/([^/?#]+)/);
    if (m) return 'View: ' + m[1].replace(/-/g, ' ').replace(/\b(\w)/g, function (c) { return c.toUpperCase(); }).slice(0, 60);
    if (/collections\/all\b/.test(u)) return 'Browse all products';
    if (/\/collections\//.test(u)) return 'View the collection';
    if (/request-support/.test(u)) return 'Request support';
    if (/contact-us/.test(u)) return 'Contact us';
    if (/\/pages\/videos/.test(u)) return 'Tech support videos';
    if (/warranty/.test(u)) return 'Warranty policy';
    if (/refund|return/.test(u)) return 'Returns';
    if (/shipping/.test(u)) return 'Shipping';
    if (/\/account/.test(u)) return 'Your account';
    if (/usps|ups\.com|fedex/.test(u)) return 'Track the package';
    if (/youtu/.test(u)) return 'Watch the video';
    return 'Open';
  }
  function handleOf(u) { var m = /^https:\/\/(www\.)?selletonscales\.com\/products\/([a-z0-9\-]+)/i.exec(u); return m ? m[2] : ''; }
  var money = function (cents) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100); } catch (e) { return '$' + (cents / 100).toFixed(2); } };
  var cache = {};
  function fillCard(a) {
    var h = a.getAttribute('data-handle');
    cache[h] = cache[h] || fetch('/products/' + h + '.js', { headers: { accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    cache[h].then(function (p) {
      if (!p) { a.classList.add('se-ask__card--plain'); return; }
      var img = p.featured_image ? String(p.featured_image).replace(/^\/\//, 'https://') : '';
      if (img) a.querySelector('.se-ask__img').innerHTML = '<img src="' + esc(img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=112') + '" alt="" width="56" height="56" loading="lazy">';
      else a.classList.add('se-ask__card--plain');
      a.querySelector('.se-ask__name').textContent = p.title.length > 70 ? p.title.slice(0, 67) + '...' : p.title;
      a.querySelector('.se-ask__price').textContent = (p.price_varies ? 'From ' : '') + money(p.price_min);
    });
  }
  function render(box, text, techHelp, q, titles) {
    var links = [], body = [];
    String(text).split('\n').forEach(function (line) {
      var t = line.trim();
      if (/^https?:\/\//.test(t)) { if (SAFE.test(t)) links.push(t); }
      else if (!/^open tech help\.?$/i.test(t)) body.push(t);
    });
    var html = '<p class="se-ask__text">' + esc(body.join('\n').trim().replace(/tech@selletonscales\.com/gi, 'tech@selletonscales.com')).replace(/\n{2,}/g, '</p><p class="se-ask__text">').replace(/\n/g, '<br>') + '</p>';
    links = links.slice(0, 4);
    var cards = links.filter(handleOf), others = links.filter(function (u) { return !handleOf(u); });
    // Products show as small cards (rules 29 and 30): the real photo and price come from the store's own product page data.
    if (cards.length) html += '<div class="se-ask__cards">' + cards.map(function (u) { return '<a class="se-ask__card" href="' + esc(u) + '" data-handle="' + esc(handleOf(u)) + '"><span class="se-ask__img"></span><span class="se-ask__name">' + esc(label(u, titles)) + '</span><span class="se-ask__price"></span></a>'; }).join('') + '</div>';
    if (others.length) html += '<div class="se-ask__links">' + others.map(function (u) { return '<a href="' + esc(u) + '">' + esc(label(u, titles)) + '</a>'; }).join('') + '</div>';
    if (techHelp && window.seTechChat) html += '<button type="button" class="se-ask__tech">Open tech help</button>';
    box.innerHTML = html;
    box.querySelectorAll('.se-ask__card').forEach(fillCard);
    var b = box.querySelector('.se-ask__tech');
    if (b) b.addEventListener('click', function () { window.seTechChat.open(q); });
  }

  function attach(form) {
    var input = form.querySelector('[data-live-search-input]');
    if (!input || input.dataset.seAsk) return;
    input.dataset.seAsk = '1';
    var panel = document.createElement('div');
    panel.className = 'se-ask'; panel.hidden = true;
    panel.innerHTML = '<button type="button" class="se-ask__row"><span class="se-ask__badge">Ask SellEton</span><span class="se-ask__q"></span></button><div class="se-ask__answer" aria-live="polite"></div>';
    if (getComputedStyle(form).position === 'static') form.style.position = 'relative';
    // Right after the box, before the product results, so the answer shows first at every width.
    var anchor = input;
    while (anchor.parentElement && anchor.parentElement !== form) anchor = anchor.parentElement;
    if (anchor.parentElement === form) anchor.insertAdjacentElement('afterend', panel); else form.appendChild(panel);
    var row = panel.querySelector('.se-ask__row'), qspan = panel.querySelector('.se-ask__q'), answer = panel.querySelector('.se-ask__answer');

    // Moving words: the hint rotates while the box is idle; it stops on focus and for reduced motion.
    var i = 0;
    function rotate() { if (document.activeElement !== input && !input.value) { i = (i + 1) % HINTS.length; input.setAttribute('placeholder', HINTS[i]); } }
    if (!reduce) setInterval(rotate, 3000);
    input.addEventListener('focus', function () { if (!input.value) input.setAttribute('placeholder', HINTS[i]); });

    function show() {
      var q = input.value;
      if (isQuestion(q)) { qspan.textContent = q.trim(); panel.hidden = false; answer.innerHTML = ''; }
      else panel.hidden = true;
    }
    function ask() {
      var q = input.value.trim();
      if (!q) return;
      answer.innerHTML = '<p class="se-ask__wait">Finding the answer</p>';
      fetch(ENDPOINT, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ q: q, sid: 's' + opened.toString(36), t: Date.now() - opened, hp: '' }) })
        .then(function (r) { return r.json(); })
        .then(function (d) { render(answer, d.answer || '', !!d.techHelp, q, d.titles || {}); })
        .catch(function () { render(answer, 'Sorry, something went wrong. You can ask us here:\nhttps://selletonscales.com/pages/request-support', false, q); });
    }
    input.addEventListener('input', show);
    row.addEventListener('click', function (e) { e.preventDefault(); ask(); });
    form.addEventListener('submit', function (e) { if (isQuestion(input.value)) { e.preventDefault(); e.stopImmediatePropagation(); panel.hidden = false; qspan.textContent = input.value.trim(); ask(); } }, true);
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) panel.hidden = true; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.hidden = true; });
  }

  function scan() { document.querySelectorAll('form[data-live-search-form]').forEach(attach); }
  scan();
  document.addEventListener('DOMContentLoaded', scan);
})();
